/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2021 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { orderdetailobject } from './orderdetail';

export class paymentrequest extends IceEntity {
  transactiontype: string = "";
  paymentmethod: string = "";
  cardnumber: string = "";
  expirationdate: string = "";
  cardcode: string = "";
  invoicenumber: string = "";
  invoicedescription: string = "";
  firstname: string = "";
  lastname: string = "";
  bankaccounttype: string = "";
  bankroutingnumber: string = "";
  bankaccountnumber: string = "";
  bankname: string = "";
  nameonaccount: string = "";

  gettablename(): string {
    return "PAYMENT_REQUEST";
  }
}
